import { SvgIcon, SvgIconProps } from '@mui/material'

const MailBox = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg id="mail-box-mailbox-svgrepo-com" xmlns="http://www.w3.org/2000/svg" width="17.176" height="18.321" viewBox="0 0 17.176 18.321">
                <g id="Group_144222" data-name="Group 144222" transform="translate(11.451)">
                    <path id="Path_41415" data-name="Path 41415" d="M21.573,10.878A.541.541,0,0,1,21,10.306V.573A.541.541,0,0,1,21.573,0h4.58a.541.541,0,0,1,.573.573v2.29a.541.541,0,0,1-.573.573H22.145v6.87A.541.541,0,0,1,21.573,10.878Z" transform="translate(-21)" fill="var(--tirnary-text-color)" />
                </g>
                <path id="Path_41416" data-name="Path 41416" d="M8.958,13.566A4.512,4.512,0,0,0,5.008,9.1,4.571,4.571,0,0,0,1,13.623V18.2a.541.541,0,0,0,.573.573H8.958Z" transform="translate(-1 -3.89)" fill="var(--tirnary-text-color)" />
                <path id="Path_41417" data-name="Path 41417" d="M12,28v1.718a.541.541,0,0,0,.573.573h3.435a.541.541,0,0,0,.573-.573V28Z" transform="translate(-5.702 -11.969)" fill="var(--tirnary-text-color)" />
                <path id="Path_41418" data-name="Path 41418" d="M19.87,9.172v4.981a.573.573,0,0,1-1.145,0V9H13a5.641,5.641,0,0,1,2.233,4.523v5.21h7.5a.541.541,0,0,0,.573-.573V13.58A4.6,4.6,0,0,0,19.87,9.172Z" transform="translate(-6.13 -3.847)" fill="var(--tirnary-text-color)" />
            </svg>
        </SvgIcon>
    )
}

export default MailBox

